import React from "react";

type CheckboxProps = Omit<React.ComponentPropsWithoutRef<"input">, "className" | "style" | "type">;

export function LabelledCheckbox({ label, ...props }: CheckboxProps & { label: React.ReactChild }) {
  return (
    <label className="tw-flex tw-items-center tw-gap-2">
      <input {...props} type="checkbox" className="tw-m-0 focus-visible:tw-outline-offset-[3px]" />
      {label}
    </label>
  );
}
